export default {
    Compliance: 'compliance',
    Full: 'full'
}